module.exports = __webpack_public_path__ + "static/media/celulitis.51890724.jpg";